import { useClosingRetrieveSuspense } from "gen/endpoints/closing/closing";
import { useFundFamilyEventRetrieve } from "gen/endpoints/fund-family-event/fund-family-event";
import { Outlet } from "react-router-dom";
import { FullScreenLoadingState } from "shared/components/empty/FullScreenLoadingState";
import PageBody from "shared/components/layout/PageBody";
import PageContent from "shared/components/layout/PageContent";
import { useRequiredStringParams } from "shared/hooks/useRequiredStringParams";

export const ClosingPageWrapper: React.FC = () => {
  const { fundFamilyId, closingId } = useRequiredStringParams();
  const { data: closingData } = useClosingRetrieveSuspense(
    fundFamilyId,
    closingId,
  );

  const { data: fundFamilyEventData } = useFundFamilyEventRetrieve(
    fundFamilyId,
    closingData.fund_family_event_id,
    {
      query: {
        enabled: !!closingData,
        refetchInterval: 1000,
      },
    },
  );

  if (fundFamilyEventData?.event_workflow_status.is_running) {
    return (
      <PageContent isFullHeight={true}>
        <PageBody>
          <FullScreenLoadingState
            message={fundFamilyEventData.event_workflow_status.message}
          />
        </PageBody>
      </PageContent>
    );
  }

  return <Outlet />;
};
